import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const PlayFilledIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-play-filled', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path d='M2.00048 3.26651V12.7335C1.98491 12.9493 2.02932 13.1652 2.12887 13.3577C2.22843 13.5503 2.37932 13.7121 2.56514 13.8255C2.75097 13.939 2.96461 13.9998 3.18285 14.0013C3.40108 14.0028 3.61556 13.9449 3.80295 13.834L13.2451 9.10054C13.4677 9.0133 13.6588 8.86171 13.7934 8.66545C13.928 8.46919 14 8.23734 14 8C14 7.76266 13.928 7.53081 13.7934 7.33455C13.6588 7.13829 13.4677 6.9867 13.2451 6.89946L3.80295 2.16598C3.61556 2.05509 3.40108 1.99725 3.18285 1.99875C2.96461 2.00025 2.75097 2.06103 2.56514 2.17449C2.37932 2.28795 2.22843 2.44974 2.12887 2.64227C2.02932 2.83481 1.98491 3.05071 2.00048 3.26651Z' />
    </svg>
  );
};

export default PlayFilledIcon;
